// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22MOw","badges":"styles_badges__1K7SV"};